/* review-workspace-core.jsx — Ported from Viper `handoff-review-page`
   (`blocks-core.jsx`, `be-editor.jsx`) 2026-09-03 — ADAPTED to the live app:
   html-backed blocks over `window.GooseReviewBlocks` (D7 derived = overlay),
   `BeFrame` on the D9 first-implementation sandbox (`allow-same-origin`, scripts
   impossible), Chase gated on `GooseAPI.proposeAmendment`. */

const BIcon = ({ d, size = 16, sw = 1.7, fill, children, style, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill || 'none'} stroke={fill ? 'none' : 'currentColor'}
    strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={style} className={className}>
    {d ? <path d={d} /> : children}
  </svg>
);
const BI = {
  chevron: p => <BIcon {...p} d="M9 6l6 6-6 6" />,
  code: p => <BIcon {...p} d="M8 8l-4 4 4 4M16 8l4 4-4 4" />,
  check: p => <BIcon {...p} d="M5 12.5l4.5 4.5L19 6.5" />,
  x: p => <BIcon {...p} d="M6 6l12 12M18 6L6 18" />,
  warn: p => <BIcon {...p}><path d="M12 9v4.5M12 17h.01" /><path d="M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" /></BIcon>,
  image: p => <BIcon {...p}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="8.5" cy="9" r="1.5" /><path d="M21 16l-5-5L5 20" /></BIcon>,
  type: p => <BIcon {...p} d="M5 6.5h14M12 6.5V18M9 18h6" />,
  grid: p => <BIcon {...p}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18M3 14.5h18M9 5v14" /></BIcon>,
  cursor: p => <BIcon {...p} d="M6 3l12 8.5-5.5 1L15 20l-2.2.9-2.6-7.4L6 17z" />,
  minus: p => <BIcon {...p} d="M4 12h16" />,
  doc: p => <BIcon {...p}><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5" /></BIcon>,
  layers: p => <BIcon {...p} d="M12 3 3 8l9 5 9-5-9-5ZM3 13l9 5 9-5M3 17.5l9 5 9-5" />,
  jet: p => <BIcon {...p} fill="currentColor" d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />,
  send: p => <BIcon {...p} d="M4 12 20 4l-6 16-3-7z M11 13l9-9" />,
  link: p => <BIcon {...p} d="M10 13.5a3.5 3.5 0 0 0 5 0l3-3a3.5 3.5 0 0 0-5-5l-1.5 1.5M14 10.5a3.5 3.5 0 0 0-5 0l-3 3a3.5 3.5 0 0 0 5 5l1.5-1.5" />,
  retry: p => <BIcon {...p} d="M4 12a8 8 0 1 1 2.3 5.6M4 18v-4h4" />,
  sliders: p => <BIcon {...p} d="M5 7h9M17.5 7H19M5 17h3M11.5 17H19M15.5 4.5v5M9.5 14.5v5" />,
  review: p => <BIcon {...p}><path d="M9 11.5l2 2 4-4.5" /><rect x="3" y="3.5" width="18" height="17" rx="3" /></BIcon>,
  desktop: p => <BIcon {...p}><rect x="3" y="4.5" width="18" height="12" rx="2" /><path d="M9 20h6M12 16.5V20" /></BIcon>,
  mobile: p => <BIcon {...p}><rect x="7" y="3" width="10" height="18" rx="2.5" /><path d="M11 18.5h2" /></BIcon>,
  eye: p => <BIcon {...p}><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" /><circle cx="12" cy="12" r="3" /></BIcon>,
  chat: p => <BIcon {...p} d="M21 11.5a8 8 0 0 1-11.5 7.2L4 20.5l1.8-5.3A8 8 0 1 1 21 11.5Z" />,
  tag: p => <BIcon {...p}><path d="M3.5 11.5 11 4h7.5V11.5L11 19z" /><circle cx="14.5" cy="8.5" r="1.3" fill="currentColor" stroke="none" /></BIcon>,
  add: p => <BIcon {...p} d="M12 5v14M5 12h14" />,
  flame: p => <BIcon {...p} d="M12 3c.6 3.2 3.8 4.2 3.8 8a3.8 3.8 0 1 1-7.6 0c0-1.1.4-2 .9-2.8.5 1.1 1.1 1.6 2 1.7C10.4 7.6 10.8 5 12 3Z" />,
  clock: p => <BIcon {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></BIcon>,
  expand: p => <BIcon {...p} d="M9 4H4v5M15 4h5v5M15 20h5v-5M9 20H4v-5" />,
  shrink: p => <BIcon {...p} d="M4 9h5V4M20 9h-5V4M20 15h-5v5M4 15h5v5" />,
  undo: p => <BIcon {...p} d="M4 12a8 8 0 1 0 2.3-5.6M4 6v4h4" />,
  at: p => <BIcon {...p}><circle cx="12" cy="12" r="3.6" /><path d="M15.6 12v1.9a2.4 2.4 0 0 0 4.8 0V12a8.4 8.4 0 1 0-3.3 6.7" /></BIcon>,
};

/* ---------- code editor (CodeMirror, same core as the branch) ---------- */
function CmBox({ value, onChange, height, marks, sel, onSelBlock }) {
  const host = React.useRef(null), cm = React.useRef(null), cb = React.useRef(onChange);
  const hook = React.useRef({});
  cb.current = onChange;
  hook.current = { onSelBlock: onSelBlock, marks: marks };
  React.useEffect(() => {
    if (cm.current || !host.current || !window.CodeMirror) return;
    const i = window.CodeMirror(host.current, { value, mode: 'htmlmixed', lineNumbers: true, lineWrapping: true, tabSize: 2, indentUnit: 2 });
    i.setSize('100%', height || 200);
    i.on('change', (x) => cb.current(x.getValue()));
    /* Clicking inside a block's line range selects it, so the code pane drives
       selection the same way the render does. */
    i.on('cursorActivity', () => {
      const h = hook.current;
      if (!h.onSelBlock || !h.marks) return;
      const ln = i.getCursor().line;
      const hit = h.marks.find((m) => ln >= m.from && ln <= m.to);
      if (hit) h.onSelBlock(hit.id);
    });
    cm.current = i;
  }, []);
  React.useEffect(() => {
    const i = cm.current;if (!i || value === i.getValue()) return;
    const c = i.getCursor();i.setValue(value);try {i.setCursor(c);} catch (e) {}
  }, [value]);
  /* Paint one background class per block's line span; the selected block gets a
     stronger tint and is scrolled into view. */
  React.useEffect(() => {
    const i = cm.current;if (!i || !marks) return;
    const n = i.lineCount();
    for (let l = 0; l < n; l++) {
      i.removeLineClass(l, 'background', 'cm-blk');
      i.removeLineClass(l, 'background', 'cm-blk-sel');
      i.removeLineClass(l, 'background', 'cm-blk-alt');
    }
    marks.forEach((m, idx) => {
      for (let l = m.from; l <= m.to && l < n; l++) {
        i.addLineClass(l, 'background', m.id === sel ? 'cm-blk-sel' : idx % 2 ? 'cm-blk-alt' : 'cm-blk');
      }
    });
    const cur = marks.find((m) => m.id === sel);
    if (cur) {
      const c = i.getCursor().line;
      if (c < cur.from || c > cur.to) i.scrollIntoView({ line: cur.from, ch: 0 }, 60);
    }
  }, [marks, sel, value]);
  if (!window.CodeMirror) return <textarea className="cm-fallback" spellCheck={false} value={value} onChange={(e) => onChange(e.target.value)} style={{ height: height || 200 }} />;
  return <div className="cm-host" ref={host} style={{ height: height || 200 }}></div>;
}

/* ---------- html-backed state ---------- */
function useBuildBlocks({ html, setHtml, findings, isLive, model = null, projection = null, revisionIdentity = null, canMutate = () => true }) {
  const RB = window.GooseReviewBlocks;
  // Preview URL renewal returns a new object for the same immutable projection.
  const bindingKey = JSON.stringify([revisionIdentity, projection]);
  /* D7: derived bands are a display overlay over the real HTML bytes, never authority. */
  const local = React.useMemo(() => model ? null : RB.blocksFromHtml(html, { findings }), [html, findings, model]);
  const [projectedDraft, setProjectedDraft] = React.useState(null);
  const blocks = model ? projectedDraft && projectedDraft.bindingKey === bindingKey && projectedDraft.html === html
    ? projectedDraft.blocks : model.blocks : local.blocks;
  const manualEdits = projectedDraft && projectedDraft.bindingKey === bindingKey && projectedDraft.html === html ? projectedDraft.manualEdits || null : null;
  const derived = model ? { ...model, blocks, index: { ok: blocks.length > 0,
    bands: blocks.map((block) => ({ sec: block.id, label: block.label, range: block.range, identity: block.identity })) } } : local;
  /* FLYWHEEL §4.3: one active_block_id. `sel` is the only selection state. */
  const [sel, setSel] = React.useState(() => blocks[0] && blocks[0].id);
  const [touched, setTouched] = React.useState(() => new Set());
  const [log, setLog] = React.useState([]);
  /* D5: these whole-HTML snapshots are local draft history, not durable revisions. */
  const [hist, setHist] = React.useState(() => [{
    vid: 'v0', at: Date.now(), who: 'pipeline', kind: 'base',
    summary: 'Build as delivered by the pipeline', snap: html || '', blocks: model ? blocks : null,
  }]);
  const previousBlocks = React.useRef(blocks);
  // One retained Code buffer for the inspector and both full-screen scopes.
  // It is bound to the local draft it started from, not merely the server head.
  const [codeDraft, setCodeDraft] = React.useState(null);
  const codeStale = !!codeDraft && (codeDraft.base !== html || codeDraft.bindingKey !== bindingKey);
  const codeDirty = !!codeDraft && (codeDraft.html !== html || codeStale);
  const mark = (id) => setTouched(t => (t.has(id) ? t : new Set([...t, id])));
  const note = (t) => setLog(l => [...l, t].slice(-6));
  const mutationAllowed = (allowCode = false) => {
    if (!allowCode && codeDirty) { note('Apply or revert the retained Code draft before another edit.');return false; }
    if (canMutate()) return true;
    note('Wait for the current revision operation to finish before editing.');return false;
  };
  const push = (e, nextHtml) => setHist(h => {
    const last = h[h.length - 1];
    if (last && e.mergeKey && last.mergeKey === e.mergeKey && Date.now() - last.at < 6000) {
      return [...h.slice(0, -1), { ...last, ...e, at: Date.now(), snap: nextHtml, n: (last.n || 1) + 1 }];
    }
    return [...h, { ...e, vid: 'v' + h.length + '-' + Date.now(), at: Date.now(), snap: nextHtml }];
  });

  React.useEffect(() => {
    setHist(h => {
      if (h.length === 1 && h[0].snap === '' && html) return [{ ...h[0], snap: html, blocks: model ? blocks : null }];
      return h;
    });
  }, [html]);

  React.useEffect(() => {
    const before = previousBlocks.current;
    const beforeCount = before.length;
    const afterCount = blocks.length;
    if (beforeCount !== afterCount && !blocks.some(b => b.id === sel)) {
      const oldIndex = Math.max(0, before.findIndex(b => b.id === sel));
      const next = blocks[Math.min(oldIndex, Math.max(0, afterCount - 1))];
      setSel(next ? next.id : undefined);
      note('Section count changed (' + beforeCount + ' → ' + afterCount + ') — selection re-seated');
    }
    previousBlocks.current = blocks;
  }, [blocks.length]);
  React.useEffect(() => {previousBlocks.current = blocks;}, [blocks]);

  const setCode = (id, code, why, meta = {}) => {
    if (!mutationAllowed()) return;
    const b = blocks.find(x => x.id === id);
    if (!b || !b.range) {note('Apply the document changes or reload before editing this block — its source range changed');return;}
    const next = RB.spliceBand(html, derived.index, id, code);
    if (next === html) return;
    const nextBlocks = model ? RB.rebaseBlocks(blocks, html, next, [{ ...b.range, blockId: id, text: String(code ?? '') }]) : null;
    if (model) setProjectedDraft({ bindingKey, html: next, blocks: nextBlocks });
    setHtml(next);mark(id);
    if (why) note(why);
    const byChase = meta.who === 'chase'; // TE-123 B: caller identity, never words like "purchase" in a label.
    push({
      who: byChase ? 'chase' : 'jd', kind: byChase ? 'chase' : 'code',
      blockId: id, label: b && b.label, blocks: nextBlocks,
      summary: byChase ? (why || '').replace(/^Chase\s*·\s*/i, '') : 'Edited the block source by hand',
    }, next);
  };
  const setCodes = (map, summary) => {
    if (!mutationAllowed()) return;
    const ids = Object.keys(map || {});
    if (!ids.length) return;
    const next = RB.spliceBands(html, derived.index, map);
    const edits = blocks.filter((block) => block.range && ids.includes(block.id)).map((block) => ({ ...block.range, blockId: block.id, text: String(map[block.id] ?? '') }));
    const nextBlocks = model ? RB.rebaseBlocks(blocks, html, next, edits) : null;
    if (model) setProjectedDraft({ bindingKey, html: next, blocks: nextBlocks });
    setHtml(next);
    setTouched(t => new Set([...t, ...ids]));
    push({ who: 'jd', kind: 'code', blockId: null, label: null, blocks: nextBlocks, summary: summary || ('Whole-file edit — ' + ids.length + ' blocks') }, next);
  };
  const changedBlocks = (nextHtml) => model
    ? RB.rebaseBlocks(blocks, html, nextHtml).filter((block, index) => !block.range || block.code !== blocks[index].code).map((block) => block.id)
    : RB.diffBands(html, nextHtml);
  const setWhole = (nextHtml, summary, retainedBlocks = null) => {
    if (!mutationAllowed(!!retainedBlocks)) return false;
    const ids = changedBlocks(nextHtml);
    const nextBlocks = model ? retainedBlocks || RB.rebaseBlocks(blocks, html, nextHtml) : null;
    if (model) setProjectedDraft({ bindingKey, html: nextHtml, blocks: nextBlocks });
    setHtml(nextHtml);
    setTouched(t => new Set([...t, ...ids]));
    push({ who: 'jd', kind: 'code', blockId: null, label: null, blocks: nextBlocks, summary: summary || 'Edited the whole file' }, nextHtml);
    return true;
  };
  const updateCodeDraft = (value, id = null) => {
    if (!mutationAllowed(true)) return;
    setCodeDraft(prior => {
      if (prior && (prior.base !== html || prior.bindingKey !== bindingKey)) { note('The Code draft base changed. Copy your edits, then revert and reapply them to the current file.');return prior; }
      const current = prior || { base: html, bindingKey, html, blocks, history: [] };
      const block = id == null ? null : current.blocks.find(b => b.id === id);
      if (id != null && !block?.range) { note('This section cannot be located safely in the Code draft. Use Whole file to repair it.');return prior; }
      const next = block ? current.html.slice(0, block.range.start) + value + current.html.slice(block.range.end) : value;
      if (next === current.html) return prior;
      if (next === current.base) return null;
      const nextBlocks = RB.rebaseBlocks(current.blocks, current.html, next, block ? [{ ...block.range, blockId: id, text: value }] : null);
      const checkpoint = { html: current.html, blocks: current.blocks };
      const merge = prior && prior.scope === id && Date.now() - prior.at < 1000;
      return { ...current, html: next, blocks: nextBlocks, scope: id, at: Date.now(),
        history: merge ? current.history : [...current.history, checkpoint].slice(-50) };
    });
  };
  const applyCodeDraft = () => {
    if (!codeDirty || !mutationAllowed(true)) return false;
    if (codeStale) { note('The Code draft base changed. Copy your edits, then revert and reapply them to the current file.');return false; }
    if (!setWhole(codeDraft.html, 'Applied retained Code draft', codeDraft.blocks)) return false;
    setCodeDraft(null);return true;
  };
  const discardCodeDraft = () => { if (mutationAllowed(true)) setCodeDraft(null); };
  const undoCodeDraft = () => {
    if (!mutationAllowed(true)) return;
    setCodeDraft(prior => {
      if (!prior?.history.length) return prior;
      const restored = prior.history.at(-1);
      if (restored.html === prior.base && prior.base === html && prior.bindingKey === bindingKey) return null;
      return { ...prior, ...restored, history: prior.history.slice(0, -1), at: 0 };
    });
  };
  const revertTo = (vid) => {
    if (!mutationAllowed()) return;
    const e = hist.find(x => x.vid === vid);if (!e) return;
    if (model) setProjectedDraft({ bindingKey, html: e.snap, blocks: e.blocks || model.blocks, manualEdits: e.manualEdits || null });
    setHtml(e.snap);
    push({ who: 'jd', kind: 'revert', blockId: null, label: null, blocks: e.blocks, manualEdits: e.manualEdits || null, summary: 'Reverted to “' + e.summary + '”' }, e.snap);
  };
  const resetEdits = () => {
    // v0 is this editor session's saved head, not the pipeline's original r0.
    // Clear both draft layers together; discardCodeDraft + revertTo would race
    // the retained-Code guard. No server mutation or revision restore occurs.
    if (!mutationAllowed(true) || !hist[0]) return false;
    const base = hist[0];
    setCodeDraft(null);
    setProjectedDraft(null);
    setHtml(base.snap);
    setTouched(new Set());
    push({ who: 'jd', kind: 'revert', blockId: null, label: null, blocks: base.blocks,
      manualEdits: null, summary: 'Reset unsaved edits to the saved revision' }, base.snap);
    note('Unsaved edits reset. Saved revisions and assets are unchanged.');
    return true;
  };
  const hasFields = (id) => {
    const b = blocks.find(x => x.id === id);
    return !!(b && Object.values(b.fields || {}).some(f => f?.schema === 'ArtifactField.v1'));
  };
  const setProps = (id, values) => {
    if (!mutationAllowed()) return { ok: false, error: 'Wait for the current revision operation to finish.' };
    const block = blocks.find(b => b.id === id);
    if (!model || !block?.range) return { ok: false, error: 'Manual editing needs the current server-bound section.' };
    try {
      const edit = RB.applyFieldEdits(block.code, block.fields, values);
      if (!edit.changed) return { ok: true };
      const nextHtml = RB.spliceBand(html, derived.index, id, edit.code);
      const nextBlocks = RB.rebaseBlocks(blocks, html, nextHtml, [{ ...block.range, blockId: id, text: edit.code }]).map(b => b.id !== id ? b : {
        ...b, fields: edit.fields, p: Object.fromEntries(Object.entries(edit.fields).map(([key, f]) => [key, f.value])),
        custom: false, manual_unavailable: null,
      });
      const prior = html === hist[0].snap ? {} : manualEdits;
      const receipt = prior && { ...prior, [id]: { ...(prior[id] || {}), ...Object.fromEntries(Object.keys(values).map(key => [key, edit.fields[key].value])) } };
      setProjectedDraft({ bindingKey, html: nextHtml, blocks: nextBlocks, manualEdits: receipt });
      setHtml(nextHtml);mark(id);
      const names = Object.keys(values).map(key => edit.fields[key].l).join(', ');
      push({ who: 'jd', kind: 'manual', blockId: id, label: block.label, blocks: nextBlocks, manualEdits: receipt,
        mergeKey: 'manual:' + id + ':' + Object.keys(values).sort().join(','), summary: 'Manual edit · ' + names }, nextHtml);
      return { ok: true };
    } catch (error) {
      note(error.message);return { ok: false, error: error.message };
    }
  };
  const setProp = (id, key, value) => setProps(id, { [key]: value });
  // A projection is not a recipe. Never overwrite a developer's code by
  // reconstructing this block from the inspector's subset of fields.
  const regen = () => note('Apply and rerun QA to refresh fields from the actual file. No source is regenerated from inspector values.');
  const cur = blocks.find(b => b.id === sel) || blocks[0];
  return {
    ok: derived.ok, reason: derived.reason, identity: derived.identity,
    blocks, index: derived.index, unplaced: derived.unplaced, source: model ? 'projection' : 'local', changedBlocks,
    sel, setSel, cur, setCode, setCodes, setWhole, revertTo, resetEdits,
    hasFields, setProp, setProps, regen, touched, log, note, hist,
    editor: { html: codeDraft?.html ?? html, blocks: codeDraft?.blocks || blocks, dirty: codeDirty, stale: codeStale,
      setBlock: (id, value) => updateCodeDraft(value, id), setWhole: value => updateCodeDraft(value),
      apply: applyCodeDraft, discard: discardCodeDraft, undo: undoCodeDraft, canUndo: !!codeDraft?.history.length },
    manualEdits: manualEdits ? Object.entries(manualEdits).map(([block_id, changes]) => ({ block_id, changes })) : null,
  };
}

/* ---------- live render ---------- */
function rwIsolatedPreview(session) {
  return session && session.capabilities && session.capabilities.isolated_preview === true
    && session.preview && typeof session.preview.assets_base === 'string' && /^https?:\/\//i.test(session.preview.assets_base)
    ? { on: true, assetsBase: session.preview.assets_base } : { on: false, assetsBase: null };
}

function BeFrame({ html, sel, onSel, width, zoom, fit, fitH, patched, resizeKey, onOverflow, onFrame, onGeometry, artifactUrl, isolated }) {
  const RB = window.GooseReviewBlocks;
  const bridgeOn = !!(isolated && isolated.on);
  const assetsBase = bridgeOn ? isolated.assetsBase : null;
  const display = React.useMemo(() => {
    if (!bridgeOn) return RB.buildDisplayDoc(html, { artifactUrl });
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    const nonce = btoa(String.fromCharCode(...bytes));
    return RB.buildDisplayDoc(html, { artifactUrl, bridge: { nonce, assetsOrigin: new URL(assetsBase).origin } });
  }, [html, artifactUrl, bridgeOn, assetsBase]);
  const ref = React.useRef(null), cb = React.useRef({}), wrap = React.useRef(null);
  const [ww, setWw] = React.useState(0);
  const [wh, setWh] = React.useState(0);
  const [docH, setDocH] = React.useState(0);
  const [ov, setOv] = React.useState(null);
  const [frameState, setFrameState] = React.useState('loading');
  const remeasure = React.useRef(null);
  const frameCb = React.useRef(onFrame);
  const geometryRequest = React.useRef(null), geometrySerial = React.useRef(0), geometryReady = React.useRef(null);
  const geometryValue = React.useRef();
  const w = width || 600;
  cb.current = { onSel, sel, patched, onGeometry, html: String(html || ''), viewportWidth: w, displayDoc: display.doc };
  frameCb.current = onFrame;
  /* Invalidate synchronously so a late message cannot publish between a new
     render and its effects. Geometry always belongs to this exact HTML/width/id. */
  const pending = geometryRequest.current;
  if (pending && (pending.doc !== display.doc || pending.html !== cb.current.html
    || pending.viewportWidth !== w || pending.regionId !== sel)) geometryRequest.current = null;
  /* Fit measurement must not depend on anything the fit itself changes. The
     wrapper is width:100% of the host's content box, so its own width is
     already scrollbar-corrected — measuring the host instead fed the scaled
     paper's height back into the width (scrollbar appears → narrower → smaller
     zoom → shorter → scrollbar goes → …) and the render visibly jittered.
     Sub-pixel deltas are ignored for the same reason. */
  /* Read the wrapper fresh on every call: capturing it once meant that after a
     remount the observer measured a detached node and the stale value stuck. */
  const measureNow = () => {
    const box = wrap.current;if (!box) return;
    const host = box.parentElement || box;
      /* Measure the HOST's content box, not the wrapper: the wrapper is sized by
         the paper it contains, so reading it fed the fit its own output and the
         first measurement stuck forever. */
      const cs = window.getComputedStyle(host);
      const availW = host.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      const availH = host.clientHeight - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0);
    /* An unmeasured host must stay unmeasured: a floor turned "no layout yet"
       into a legitimate-looking 60px and the render painted at 10% zoom. */
    if (availW > 0) setWw(p => (Math.abs(p - availW) > 1 ? availW : p));
    if (availH > 0) setWh(p => (Math.abs(p - availH) > 1 ? availH : p));
  };
  React.useLayoutEffect(() => {
    if (!fit || !wrap.current) return;
    const box = wrap.current;
    const host = box.parentElement || box;
    let raf = 0;
    const set = measureNow;
    /* Two frames: the first can still read a layout that is being replaced, and
       that transient value used to stick forever. */
    const queue = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; requestAnimationFrame(set); }); };
    remeasure.current = queue;
    set();
    queue();
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(queue);
      ro.observe(box);
      /* Observe the host as well: the wrapper can keep its width when the host
         shrinks (the paper inside it is explicitly sized), so watching only the
         wrapper missed panel resizes that never touch React's layout state. */
      if (host !== box) ro.observe(host);
      return () => { ro.disconnect(); if (raf) cancelAnimationFrame(raf); };
    }
    window.addEventListener('resize', queue);
    return () => { window.removeEventListener('resize', queue); if (raf) cancelAnimationFrame(raf); };
  }, [fit, width, resizeKey]);
  /* Re-measure on every commit, not just on mount — nothing else re-runs once
     the real layout resolves after the first paint. */
  React.useLayoutEffect(() => {
    if (!fit) return;
    measureNow();
    const r1 = requestAnimationFrame(() => { const r2 = requestAnimationFrame(measureNow); remeasure.raf2 = r2; });
    return () => { cancelAnimationFrame(r1); if (remeasure.raf2) cancelAnimationFrame(remeasure.raf2); };
  });
  const codes = String(html || '');
  /* Opaque origins require '*'. Only band ids, class names and a width cross
     this bridge; session credentials and artifact bytes never do. */
  const post = (o) => {
    const f = ref.current;
    if (f && f.contentWindow) f.contentWindow.postMessage(Object.assign({ goose: true }, o), '*');
  };
  const publishGeometry = (value) => {
    if (!cb.current.onGeometry) return;
    const previous = geometryValue.current;
    if (value === null ? previous === null : previous && ['regionId', 'width', 'height', 'viewportWidth', 'html'].every(key => previous[key] === value[key])) return;
    geometryValue.current = value;
    cb.current.onGeometry(value);
  };
  const measureGeometry = () => {
    const current = cb.current, f = ref.current;
    if (!current.onGeometry || !f || geometryReady.current !== current.displayDoc) return;
    /* Derived data-sec stamps are display overlays, not authored source anchors. */
    const authored = display.bands.filter(b => b.authored && b.sec === current.sel);
    if (authored.length !== 1) {geometryRequest.current = null;publishGeometry(null);return;}
    const request = { requestId: String(++geometrySerial.current), regionId: current.sel,
      renderToken: display.nonce, source: f.contentWindow, doc: current.displayDoc,
      html: current.html, viewportWidth: current.viewportWidth };
    geometryRequest.current = request;
    if (bridgeOn) {
      post({ type: 'region-geometry-req', requestId: request.requestId, regionId: request.regionId, renderToken: request.renderToken });
      return;
    }
    let geometry = null;
    try {
      const d = f.contentDocument;
      const matches = d ? Array.from(d.querySelectorAll('[data-region],[data-sec]')).filter(el =>
        el.getAttribute('data-region') === request.regionId || el.getAttribute('data-sec') === request.regionId) : [];
      if (matches.length === 1) {
        const r = matches[0].getBoundingClientRect();
        if ([r.width, r.height].every(n => typeof n === 'number' && Number.isFinite(n) && n >= 0 && n <= 1e6))
          geometry = { regionId: request.regionId, width: r.width, height: r.height,
            viewportWidth: request.viewportWidth, html: request.html };
      }
    } catch (e) {}
    publishGeometry(geometry);
  };
  const paint = () => {
    if (bridgeOn) {
      post({ type: 'mark', cls: 'gx-sel', keys: cb.current.sel ? [cb.current.sel] : [] });
      post({ type: 'mark', cls: 'gx-patch', keys: Array.from(cb.current.patched || []) });
      return;
    }
    const f = ref.current;if (!f) return;
    let d;try {d = f.contentDocument;} catch (e) {return;}
    if (!d || !d.body) return;
    d.body.querySelectorAll('[data-region],[data-sec]').forEach(el => {
      const id = el.getAttribute('data-region') || el.getAttribute('data-sec');
      el.classList.toggle('gx-sel', id === cb.current.sel);
      el.classList.toggle('gx-patch', !!(cb.current.patched && cb.current.patched.has(id)));
    });
  };
  React.useEffect(() => {
    const f = ref.current;if (!f) return;
    geometryReady.current = null;
    setFrameState('loading');
    let loaded = false;
    let failTimer = 0;
    if (bridgeOn) {
      const dimension = (n) => typeof n === 'number' && isFinite(n) && n >= 0 && n <= 1e6;
      const keys = (value) => Array.isArray(value) && value.every(k => typeof k === 'string');
      const onMessage = (e) => {
        if (!ref.current || e.source !== ref.current.contentWindow || !e.data || e.data.goose !== true) return;
        const d = e.data;
        if (d.type === 'manifest') {
          if (!dimension(d.bands) || !dimension(d.total) || !d.perBand || typeof d.perBand !== 'object'
            || Array.isArray(d.perBand) || !Object.values(d.perBand).every(dimension)) return;
          loaded = true;
          if (failTimer) clearTimeout(failTimer);
          setFrameState('ready');
          geometryReady.current = display.doc;
          paint();
          measureFit();
          measureGeometry();
        } else if (d.type === 'size') {
          if (!dimension(d.h) || !dimension(d.w)) return;
          setDocH(d.h);
          if (remeasure.current) remeasure.current();
          measureGeometry();
        } else if (d.type === 'overflow') {
          if (!dimension(d.docW) || !dimension(d.w) || !dimension(d.over) || !keys(d.blocks)) return;
          setOv(d.over > 1 ? { over: d.over, docW: d.docW, w: d.w, blocks: d.blocks } : null);
        } else if (d.type === 'select' || d.type === 'deselect') {
          if (typeof d.band !== 'string' && d.band !== null) return;
          if (d.band && cb.current.onSel) cb.current.onSel(d.band);
        } else if (d.type === 'region-geometry') {
          const request = geometryRequest.current, current = cb.current;
          if (!request || e.source !== request.source || d.requestId !== request.requestId
            || d.regionId !== request.regionId || d.renderToken !== request.renderToken
            || request.doc !== current.displayDoc || request.html !== current.html
            || request.viewportWidth !== current.viewportWidth || request.regionId !== current.sel) return;
          if (d.measured === false) {geometryRequest.current = null;publishGeometry(null);}
          else if (d.measured === true && dimension(d.width) && dimension(d.height) && current.onGeometry) {
            geometryRequest.current = null;
            publishGeometry({ regionId: request.regionId, width: d.width, height: d.height,
              viewportWidth: request.viewportWidth, html: request.html });
          }
        }
      };
      window.addEventListener('message', onMessage);
      failTimer = setTimeout(() => {if (!loaded) setFrameState('failed');}, 1500);
      try {f.srcdoc = display.doc;} catch (e) {}
      return () => {
        window.removeEventListener('message', onMessage);
        if (failTimer) clearTimeout(failTimer);
      };
    }
    const initialise = (fromLoad) => {
      let d;try {d = f.contentDocument;} catch (e) {return;}
      if (!d || !d.body) return;
      if (fromLoad) {
        loaded = true;
        if (failTimer) clearTimeout(failTimer);
        setFrameState('ready');
      }
      d.body.onclick = (e) => {
        const a = e.target && e.target.closest ? e.target.closest('a') : null;
        if (a) {e.preventDefault();e.stopPropagation();}
        const s = e.target && e.target.closest ? e.target.closest('[data-region],[data-sec]') : null;
        if (s && cb.current.onSel) cb.current.onSel(s.getAttribute('data-region') || s.getAttribute('data-sec'));
      };
      paint();
      geometryReady.current = display.doc;
      try {const h = d.documentElement ? d.documentElement.scrollHeight : 0;if (h) setDocH(h);} catch (e) {}
      if (remeasure.current) remeasure.current();
      measureFit();
      measureGeometry();
    };
    const on = () => initialise(true);
    f.addEventListener('load', on);
    /* D9: preview real bytes with a hostile-content posture. Never combine
       allow-scripts with allow-same-origin; a rendering difficulty never
       justifies weakening the sandbox. The persisted HTML is never this doc. */
    try {f.srcdoc = display.doc;} catch (e) {}
    /* srcdoc can finish before the listener attaches (and about:srcdoc never
       fires load in some paths), which left docH at 0 on first mount: the fit
       clamp was skipped and the paper fell back to a percentage height with no
       resolved parent. Poll briefly until the document reports a height. */
    let tries = 0, t = 0;
    const settle = () => {
      tries++;
      let d;try {d = f.contentDocument;} catch (err) {return;}
      const h = d && d.documentElement ? d.documentElement.scrollHeight : 0;
      if (h) {initialise(false);return;}
      if (tries < 20) t = setTimeout(settle, 50);
    };
    t = setTimeout(settle, 0);
    failTimer = setTimeout(() => {if (!loaded) setFrameState('failed');}, 1500);
    return () => {
      f.removeEventListener('load', on);
      if (t) clearTimeout(t);
      if (failTimer) clearTimeout(failTimer);
    };
  }, [display.doc]);
  React.useLayoutEffect(() => {
    geometryRequest.current = null;
    publishGeometry(null);
    measureGeometry();
    return () => {geometryRequest.current = null;};
  }, [display.doc, w, sel]);
  React.useEffect(paint, [sel, patched]);
  React.useEffect(() => {if (frameCb.current) frameCb.current(frameState);}, [frameState]);
  /* D6: browser measurements can produce a `Draft preview warning`; they are
     never certification. Wider output is still surfaced instead of hidden. */
  const measureFit = () => {
    if (bridgeOn) {post({ type: 'measure-req', w });return;}
    const f = ref.current;if (!f) return;
    let d;try {d = f.contentDocument;} catch (e) {return;}
    if (!d || !d.body) return;
    const docW = Math.max(d.documentElement.scrollWidth || 0, d.body.scrollWidth || 0);
    const over = docW - w;
    if (over > 1) {
      /* Which block actually needs more room than the viewport? Measure each
         block's content at max-content width — in a table every cell stretches
         to the widest one, so raw cell width names the wrong culprit. */
      let bestId = null, bestNeed = 0;
      const probe = d.createElement('div');
      probe.setAttribute('style', 'position:absolute;left:-99999px;top:0;visibility:hidden;width:max-content;max-width:none');
      d.body.appendChild(probe);
      d.body.querySelectorAll('[data-region],[data-sec]').forEach(cell => {
        probe.innerHTML = cell.innerHTML;
        const need = probe.getBoundingClientRect().width;
        const id = cell.getAttribute('data-region') || cell.getAttribute('data-sec');
        if (need > bestNeed) {bestNeed = need;bestId = id;}
      });
      probe.remove();
      setOv({ over: Math.round(over), docW: Math.round(docW), w: w, blocks: bestNeed > w + 1 ? [bestId] : [] });
    } else setOv(null);
  };
  React.useEffect(() => {const t = setTimeout(measureFit, 140);return () => clearTimeout(t);}, [w, docH, codes]);
  React.useEffect(() => {if (onOverflow) onOverflow(ov);}, [ov]);
  const zW = fit ? (ww ? Math.min(1, ww / w) : 1) : (zoom || 1);
  /* Height only constrains the fit where the host has a height of its own (the
     render stage). In a column that grows with its content the clamp reads back
     the paper's own height and shrinks it every pass, so it is opt-in. */
  const zRaw = fit && fitH && docH && wh ? Math.min(zW, wh / docH) : zW;
  const z = Math.round(zRaw * 500) / 500;
  const paper = (
    <div className={'bx-paper' + (ov ? ' bx-over' : '')} data-ws-frame-mode={bridgeOn ? 'isolated' : 'same-origin'} data-ws-frame={frameState} style={{ width: Math.round(w * z), height: docH ? Math.round(docH * z) : 'auto', minHeight: docH ? undefined : Math.round(w * z * 1.2) }}>
      {frameState === 'failed' && <div role="status" style={{ padding: '7px 10px', color: 'var(--fail)', fontSize: 12 }}>Preview did not initialise</div>}
      {bridgeOn
        ? <iframe key="isolated" ref={ref} title="Live render" sandbox="allow-scripts" style={{ width: w, height: docH ? docH + 'px' : (100 / z) + '%', transform: 'scale(' + z + ')', transformOrigin: 'top left' }}></iframe>
        : <iframe key="same-origin" ref={ref} title="Live render" sandbox="allow-same-origin" style={{ width: w, height: docH ? docH + 'px' : (100 / z) + '%', transform: 'scale(' + z + ')', transformOrigin: 'top left' }}></iframe>}
    </div>
  );
  // TE-113 (🐓): the wrapper is ALWAYS rendered so the iframe keeps one tree position across Fit ↔ 100%.
  // Returning `paper` bare in one branch and wrapped in the other remounted the iframe on every toggle,
  // and the srcdoc effect (keyed on the doc) never re-wrote the fresh node → blank paper, Fit never recovered.
  // Only the wrapper's style varies: flex-centred at Fit, a plain block at true 100%.
  return <div ref={wrap} style={fit ? { width: '100%', justifySelf: 'stretch', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' } : { width: '100%', justifySelf: 'stretch', display: 'block' }}>{paper}</div>;
}

function rwDiff(before, after, max) {
  const a = before.split('\n'), b = after.split('\n'), out = [];
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    if (a[i] === b[i]) {if (a[i] !== undefined) out.push({ t: 'ctx', s: a[i] });continue;}
    if (a[i] !== undefined) out.push({ t: 'del', s: a[i] });
    if (b[i] !== undefined) out.push({ t: 'add', s: b[i] });
  }
  return out.slice(0, max || 30);
}

/* ---------- gated Chase proposals ---------- */
function useBeChase({ blocks, sel, jobId, session, baseHtml = '', disabled = false, draftDirty = false, onAccepted, onAccepting }) {
  const [selectedPatchKey, setSelectedPatchKey] = React.useState(null);
  const [retainedProposalId, setRetainedProposalId] = React.useState(null);
  const [requestedScope, setScope] = React.useState('region');
  const [regionIds, setRegionIds] = React.useState([]);
  const [composerDraft, setComposerDraft] = React.useState(null);
  const regionAvailable = blocks.some((block) => block.id === sel && block.identity === 'authored');
  const scope = requestedScope === 'unconfirmed-document' ? 'document' : requestedScope === 'multi' || regionAvailable ? requestedScope : 'document';
  const multiValid = regionIds.length >= 2 && regionIds.length <= 16 && new Set(regionIds).size === regionIds.length
    && regionIds.every(id => blocks.some(block => block.id === id && block.identity === 'authored'));
  const [snapshot, setSnapshot] = React.useState({ proposals: [], operations: [] });
  const [messages, setMessages] = React.useState([]);
  const messageSequence = React.useRef(0);
  const [error, setError] = React.useState(null);
  const [listError, setListError] = React.useState(null);
  const [phase, setPhase] = React.useState(null);
  const [now, setNow] = React.useState(Date.now);
  const mounted = React.useRef(false);
  const request = React.useRef(0);
  const mutation = React.useRef(false);
  const instructions = React.useRef(new Map());
  const observed = React.useRef(new Map());
  const api = window.GooseAPI;
  const capabilities = session && session.capabilities || {};
  const hasSession = !!(session && session.revision && session.revision_digest);
  const canRead = !!(api && api.chaseProposals && hasSession && jobId);
  const wired = canRead && !!api.chasePropose && capabilities.chase === true && session.chase_availability?.available !== false;
  const canAccept = canRead && !!api.chaseAccept && capabilities.chase_accept === true;
  const active = snapshot.operations.some((op) => op.status === 'queued' || op.status === 'running' || op.cancellation_pending === true);
  const accepting = snapshot.proposals.some((proposal) => proposal.status === 'accepting');
  const recoveryHold = snapshot.operations.some(op => ['chase_dispatch_legacy_hold', 'chase_dispatch_capture_invalid'].includes(op.recovery_required));
  const busy = !!phase || active || accepting || recoveryHold;
  const unavailable = window.GooseReviewAmendments.mapAmendError(null, { code: session?.chase_availability?.reason || 'runner_unavailable' });
  const gate = unavailable.title + (unavailable.detail ? '. ' + unavailable.detail : '');
  const draftBlock = 'Apply or revert your local edits before asking or accepting Chase. Your unsaved file will not be replaced.';
  const mapError = (e) => window.GooseReviewAmendments.mapAmendError(e.status, e.data || { code: e.code || e.kind, error: e.message });

  const refresh = React.useCallback(async () => {
    if (!canRead) return null;
    const token = ++request.current;
    try {
      const result = await api.chaseProposals(jobId);
      if (!mounted.current || token !== request.current) return null;
      const operations = result.operations || [];
      operations.forEach((op) => {
        if (!observed.current.has(op.operation_id)) observed.current.set(op.operation_id, Date.now());
      });
      setSnapshot({ proposals: result.proposals || [], operations });
      setListError(null);
      return result;
    } catch (e) {
      if (mounted.current && token === request.current) setListError(mapError(e));
      return null;
    }
  }, [api, jobId, canRead]);

  React.useEffect(() => {
    mounted.current = true;
    refresh();
    return () => {mounted.current = false;request.current++;};
  }, [refresh]);
  React.useEffect(() => {refresh();}, [session]);
  React.useEffect(() => {
    const reload = (event) => {
      if (!event.detail || !event.detail.jobId || event.detail.jobId === jobId) refresh();
    };
    window.addEventListener('rw-session-refresh', reload);
    return () => window.removeEventListener('rw-session-refresh', reload);
  }, [refresh, jobId]);
  React.useEffect(() => {
    if (!canRead || !active && !accepting) return;
    let alive = true;
    const poll = async () => {
      await refresh();
      if (alive) timer = setTimeout(poll, 2000);
    };
    let timer = setTimeout(poll, 2000);
    const clock = window.setInterval(() => setNow(Date.now()), 1000);
    return () => {alive = false;clearTimeout(timer);window.clearInterval(clock);};
  }, [canRead, active, accepting, refresh]);

  const ask = async (text, opts) => {
    const instruction = (text || '').trim();
    if (!instruction || mutation.current || busy || disabled) return null;
    if (draftDirty) { setError({ code: 'draft_pending', title: draftBlock });return null; }
    const intent = opts?.intent ?? 'edit';
    if (!['edit', 'explain'].includes(intent)) { setError({ code: 'intent_invalid', title: 'Choose Propose edits or Explain only' });return null; }
    // Older finding handoffs call a single region a block; the wire contract is always region.
    const requestScope = opts && opts.scope || scope;
    const sc = requestScope === 'block' ? 'region' : requestScope;
    if (intent !== 'explain' && sc === 'document' && !opts?.scope && requestedScope !== 'document') {
      setError({ code: 'scope_required', title: 'Choose Whole file to confirm this request scope.' });return null;
    }
    const blockId = opts && opts.blockId || sel;
    const selectedIds = opts?.regionIds ?? regionIds;
    const messageId = ++messageSequence.current;
    setMessages((items) => [...items, { id: messageId, r: 'u', t: instruction, created_at: new Date().toISOString() }]);
    setError(null);
    if (!session || !session.revision || !session.revision_digest) {
      setError(mapError({ data: { code: 'cas_required' } }));return null;
    }
    if (!wired) {setError({ ...unavailable, title: gate });return { say: gate };}
    if (instruction.length > 4000) {setError({ title: 'Chase instructions must be at most 4,000 characters' });return null;}
    if (sc === 'multi' && (!Array.isArray(selectedIds) || selectedIds.length < 2 || selectedIds.length > 16 || new Set(selectedIds).size !== selectedIds.length
        || selectedIds.some(id => !blocks.some(block => block.id === id && block.identity === 'authored')))) {
      setError({ code: 'scope_invalid', title: 'Select 2–16 current builder-anchored regions. A missing region does not widen your scope.' });return null;
    }
    if (!['region', 'multi', 'document'].includes(sc) || sc === 'region' && !blocks.some((block) => block.id === blockId && block.identity === 'authored')) {
      setError({ title: 'region scope needs a builder-anchored block (RWB-1)' });return null;
    }
    mutation.current = true;
    setPhase('propose');
    try {
      const result = await api.chasePropose(jobId, {
        instruction,
        ...(intent === 'explain' ? { intent } : {}),
        scope: sc === 'region' ? { kind: 'region', region_ids: [blockId] }
          : sc === 'multi' ? { kind: 'multi', region_ids: [...selectedIds].sort() } : { kind: 'document', region_ids: [] },
        expected_head: session.revision, expected_head_digest: session.revision_digest,
      });
      if (!mounted.current) return result;
      setMessages((items) => items.map((item) => item.id === messageId ? { ...item, operation_id: result.operation_id } : item));
      request.current++;
      instructions.current.set(result.operation_id, instruction);
      observed.current.set(result.operation_id, Date.now());
      setNow(Date.now());
      setSnapshot((value) => ({ ...value, operations: [...value.operations.filter((op) => op.operation_id !== result.operation_id), result] }));
      await refresh();
      return result;
    } catch (e) {
      const failure = { ...mapError(e), instruction, intent };
      if (mounted.current) {
        setError(failure);
        // A busy response can name work started in another tab. Re-read it so it can be cancelled here.
        await refresh();
      }
      return { error: failure };
    } finally {
      mutation.current = false;
      if (mounted.current) setPhase(null);
    }
  };
  const accept = async (id, set = null) => {
    if (draftDirty) { setError({ code: 'draft_pending', title: draftBlock });return; }
    if (!canAccept || disabled || mutation.current || accepting || !session
      || !snapshot.proposals.some((proposal) => proposal.proposal_id === id && proposal.status === 'proposed')) return;
    mutation.current = true;
    setPhase('accept');setError(null);
    if (onAccepting && onAccepting(true) === false) {
      mutation.current = false;setPhase(null);return;
    }
    try {
      const result = set ? await api.chaseAcceptAll(jobId, { proposal_ids: set.proposalIds, expected_head: session.revision, expected_head_digest: session.revision_digest })
        : await api.chaseAccept(jobId, id, { expected_head: session.revision, expected_head_digest: session.revision_digest });
      if (!mounted.current) return;
      if (!/^r\d{1,6}$/.test(result?.revision?.revision || '') || !/^[a-f0-9]{64}$/.test(result?.revision?.revision_digest || '')
        || (!set && result?.proposal?.proposal_id !== id) || (set && JSON.stringify(result?.proposal_ids) !== JSON.stringify(set.proposalIds))
        || result.proposal.status !== 'accepted' || result.proposal.revision !== result.revision.revision) {
        throw Object.assign(Error('The accepted revision could not be identified. Reload history before editing.'), { code: 'chase_acceptance_invalid' });
      }
      if (onAccepted) onAccepted(result);
      window.dispatchEvent(new CustomEvent('rw-session-refresh', { detail: { jobId, reason: 'chase_accepted' } }));
    } catch (e) {
      if (mounted.current) {
        setError(mapError(e));
        if (onAccepting) onAccepting(false);
        await refresh();
      }
    } finally {
      mutation.current = false;
      if (mounted.current) setPhase(null);
    }
  };
  const change = async (kind, id) => {
    if (!canRead || disabled || mutation.current || !(kind === 'discard' ? api.chaseDiscard : api.chaseCancel)) return;
    mutation.current = true;
    setPhase(kind);setError(null);
    try {
      const result = await (kind === 'discard' ? api.chaseDiscard(jobId, id) : api.chaseCancel(jobId, id));
      if (!mounted.current) return;
      request.current++;
      setSnapshot((value) => kind === 'discard'
        ? { ...value, proposals: value.proposals.map((proposal) => proposal.proposal_id === id ? result : proposal) }
        : { ...value, operations: value.operations.map((op) => op.operation_id === id ? result : op) });
      await refresh();
    } catch (e) {if (mounted.current) setError(mapError(e));}
    finally {mutation.current = false;if (mounted.current) setPhase(null);}
  };
  const operations = snapshot.operations.map((op) => {
    const copy = window.GooseReviewAmendments.chaseOperationCopy(op);
    const legacyHold = ['chase_dispatch_legacy_hold', 'chase_dispatch_capture_invalid'].includes(op.recovery_required);
    const proposal = snapshot.proposals.find((item) => item.proposal_id === op.proposal_id);
    if (!legacyHold && op.status === 'done' && proposal && proposal.status !== 'proposed') copy.title = proposal.status === 'accepting'
      ? 'Accepting proposal · replaying and running QA…' : 'Proposal ' + proposal.status;
    const pending = op.status === 'queued' || op.status === 'running' || op.cancellation_pending === true;
    const createdAt = Date.parse(op.created_at);
    const clockNow = Math.max(now, observed.current.get(op.operation_id) || now);
    const serverClock = Number.isFinite(createdAt) && createdAt <= clockNow;
    const elapsed = Math.max(0, Math.floor((clockNow - (serverClock ? createdAt : observed.current.get(op.operation_id) || clockNow)) / 1000));
    return { ...op, copy, pending, elapsed, elapsedSource: serverClock ? 'created' : 'observed', instruction: op.instruction || instructions.current.get(op.operation_id),
      stale: !session || op.base?.revision_digest !== session.revision_digest,
      text: copy.title + (pending && !legacyHold ? ' · ' + elapsed + ' s' : '') };
  });
  const proposals = snapshot.proposals.filter((proposal) => proposal.status === 'proposed');
  const proposalSet = window.GooseReviewChase?.chaseProposalSet(proposals, session?.revision, session?.revision_digest)
    || { enabled: false, reason: 'Combined proposals are unavailable.' };
  // Compatibility projection for the existing canvas; never a local proposal queue.
  // Every patch retains its server proposal id, so Accept is one transaction for that proposal.
  const queue = proposals.flatMap((proposal) => (proposal.patches || []).map((patch) => {
    const block = blocks.find((item) => item.id === patch.region_id);
    return { pid: proposal.proposal_id, blockId: patch.region_id, before: patch.region_id === 'document' ? baseHtml : block ? block.code : '',
      stale: !session || proposal.base?.revision_digest !== session.revision_digest,
      after: patch.after_code, label: patch.region_id === 'document' ? 'Whole email' : block ? block.label : patch.region_id, why: patch.reason };
  }));
  const selectedProposal = queue.find(p => p.pid + ':' + p.blockId === selectedPatchKey)
    || queue.find(p => p.blockId === sel) || queue[0];
  const selectedPatch = queue.find(p => p.pid === selectedProposal?.pid && p.blockId === sel)
    || queue.find(p => p.pid === selectedProposal?.pid) || null;
  const msgs = [...messages, ...operations.map((op) => ({ r: 'a', t: op.text, operation_id: op.operation_id }))];
  const escalate = (item, text) => {
    const instruction = item.instruction || (text || '').trim();
    if (!instruction) return;
    setScope('document');
    return ask(instruction, { scope: 'document', intent: item.intent || 'edit' });
  };
  return { msgs, busy, phase, disabled, ask, run: ask, wired, canAccept, availabilityMessage: !wired ? gate : null, acceptBlocked: draftDirty, draftBlock: draftDirty ? draftBlock : null, scope, setScope, regionAvailable,
    regionIds, setRegionIds, multiValid, proposals, operations, queue, documentScopeExplicit: requestedScope === 'document',
    composerDraft, clearComposerDraft: () => setComposerDraft(null), prepareComposer: ({ text, regionId = null }) => {setComposerDraft({ text, regionId, key: Date.now() });setScope(regionId ? 'region' : 'unconfirmed-document');},
    retainedProposals: snapshot.proposals.filter(proposal => proposal.status !== 'proposed'),
    retainedProposalId, viewRetainedProposal: setRetainedProposalId,
    selectedPatch, selectPatch: (patch) => setSelectedPatchKey(patch ? patch.pid + ':' + patch.blockId : null),
    error, listError, refresh, escalate, accept, proposalSet,
    acceptAll: api?.chaseAcceptAll ? () => { if (proposalSet.enabled) return accept(proposalSet.proposalIds[0], proposalSet); } : undefined,
    discard: (id) => change('discard', id), cancel: (id) => change('cancel', id),
    reply: error ? error.title : !wired ? gate : operations.length ? operations[operations.length - 1].text : null };
}

/* ---------- stable render slot shared by the visual-diff workspace ---------- */
function WsRenderSlot({ device, c, isLive, job, id, label, bare, tint, triesRef, builtReady, setBuiltReady }) {
  const mobile = device === 'mobile';
  const ctaInk = c.color === '#3B3C43' ? '#1B1B1B' : '#fff';
  let liveSrc = null;
  if (isLive && window.GooseAPI && window.GooseAPI.artifactUrl) {
    if (id === 'render-built') {
      liveSrc = window.GooseAPI.artifactUrl(job.id, mobile ? '04_qa/mobile-375px.png' : '04_qa/desktop-600px.png');
    } else if (id === 'render-source') {
      // Source design render. The codex pipeline (since the ~2026-06 cutover)
      // writes the full source render to _pdf/screenshot.png (PDF briefs) or
      // _figma/screenshot.png (Figma), keyed by job.source. The pre-cutover
      // path 01_ingestion/pages/page-1.png is no longer produced — pointing at
      // it left the Source-design pane permanently blank (unlike the built
      // render, the source has no on-demand regen). Legacy/absent → the <img>
      // stays hidden via onError below.
      const shot = (job.source || 'pdf') === 'figma' ? '_figma/screenshot.png' : '_pdf/screenshot.png';
      liveSrc = window.GooseAPI.artifactUrl(job.id, shot);
    }
  }
  const [imgOk, setImgOk] = React.useState(false);
  React.useEffect(() => {setImgOk(false);}, [liveSrc, mobile]);
  // Only the built render can be generated on demand (the source comes from
  // ingestion). On a 404, fire one server-side render then bump the Review-scoped
  // counter to reload; the per-viewport cap stops a render failure from looping.
  const onImgError = () => {
    setImgOk(false);
    if (id !== 'render-built' || !(isLive && window.GooseAPI && window.GooseAPI.renderBuild)) return;
    const k = mobile ? 'm' : 'd';
    if ((triesRef.current[k] || 0) >= 2) return;
    triesRef.current[k] = (triesRef.current[k] || 0) + 1;
    window.GooseAPI.renderBuild(job.id).then(() => setBuiltReady((n) => n + 1)).catch(() => {});
  };
  const imgSrc = (liveSrc && id === 'render-built' && builtReady) ? liveSrc + '&_=' + builtReady : liveSrc;
  return (
    <figure className="rs" onDoubleClick={(e) => window.openRenderLightbox(e.currentTarget.querySelector('.rs-frame'), label + ' · ' + (mobile ? '375px mobile' : 'desktop ' + c.width + 'px'))} title="Double-click to enlarge" data-render-slot={id}>
      <div className={'rs-frame ' + (mobile ? 'rs-mobile' : 'rs-desktop')}>
        {liveSrc
          ? <img src={imgSrc} className="rs-img" alt={label} style={{ display: imgOk ? 'block' : 'none', width: '100%', height: 'auto' }} onLoad={() => setImgOk(true)} onError={onImgError} />
          : <img data-render={id} className="rs-img" alt={label} />}
        <div className="rs-render email-mock" style={{ display: liveSrc && imgOk ? 'none' : undefined }}>
          {mobile && <div className="rs-notch"></div>}
          <div style={{ background: c.accent, height: mobile ? 5 : 6 }}></div>
          <div style={{ padding: mobile ? '9px 11px' : '14px 16px' }}>
            <div style={{ height: mobile ? 11 : 13, width: mobile ? 54 : 70, background: c.color, borderRadius: 2 }}></div>
            <div style={{ height: mobile ? 62 : 80, background: 'repeating-linear-gradient(135deg,#eee,#eee 7px,#f6f6f6 7px,#f6f6f6 14px)', borderRadius: 3, margin: mobile ? '9px 0' : '11px 0', display: 'grid', placeItems: 'center', color: '#aaa', fontFamily: 'var(--mono)', fontSize: mobile ? 9 : 10 }}>hero.gif</div>
            <div style={{ height: mobile ? 8 : 9, background: '#2c2c2c', borderRadius: 2, width: '85%' }}></div>
            <div style={{ height: 6, background: '#ddd', borderRadius: 2, marginTop: 7 }}></div>
            <div style={{ height: mobile ? 56 : 50, background: tint ? '#fbe9c6' : 'repeating-linear-gradient(135deg,#eee,#eee 7px,#f6f6f6 7px,#f6f6f6 14px)', borderRadius: 3, margin: mobile ? '9px 0' : '11px 0', display: 'grid', placeItems: 'center', color: '#b89', fontFamily: 'var(--mono)', fontSize: mobile ? 9 : 10, outline: tint ? '2px solid var(--cond)' : 'none' }}>rate_table.png</div>
            <div style={{ height: mobile ? 30 : 28, background: c.accent, borderRadius: 3, display: 'grid', placeItems: 'center', color: ctaInk, fontSize: 10, fontWeight: 700 }}>CTA</div>
          </div>
        </div>
      </div>
      {!bare && <figcaption className="rs-cap"><I.image size={11} /> {label}<span className="rs-hint">⤢ dbl-click</span></figcaption>}
    </figure>
  );
}


// ── moved from review.jsx (RW-04 step 1, 2026-09-04 🐓): the workspace consumed these bare globals from the old screen; they live here
//    verbatim so review.jsx can be deleted. Contract: AFTERBURNER-QA-CONTRACT §6 phase vocabulary (labels), QA summary parse.

function parseQaSummary(md) {
  if (!md) return null;
  // First strip the front-matter style metadata blocks and pull the first
  // human-readable summary line. Real qa-report.md examples lead with a
  // "## ⛔ TEXT ACCURACY FAILURE" or "## ✅ PASS" header.
  const lines = md.split('\n');
  let heading = null, summary = null;
  for (let i = 0; i < lines.length && (!heading || !summary); i++) {
    const l = lines[i].trim();
    if (!heading && /^##\s/.test(l)) heading = l.replace(/^##\s+/, '').replace(/^[^A-Za-z]+\s*/, '');
    if (!summary && /^[^#>\s-]/.test(l) && l.length > 20 && l.length < 400) summary = l;
  }
  return { heading: heading || 'QA Report', summary: summary || md.slice(0, 280) };
}

const reviewAfterburnerPhaseLabel = {
  idle: 'Idle',
  queued: 'Queued',
  submitting_to_eoa: 'Submitting',
  fetching_renders: 'Fetching renders',
  stage_1_deterministic: 'Script checks',
  stage_2_perceptron: 'Perceptron',
  stage_3_claude: 'Claude diagnosis',
  complete: 'Complete',
  skipped: 'Skipped',
  timeout: 'Timed out',
  error: 'Error',
  interrupted: 'Interrupted',
};

function reviewAfterburnerCard(current) {
  if (!current) return { value: 'Checking…', tone: 'neutral', status: 'loading' };
  const status = current.status || 'not_started';
  if (status === 'not_started' || status === 'idle') {
    return { value: 'Not run', tone: 'neutral', status };
  }
  if (status === 'queued' || status === 'running') {
    const rawPhase = current.phase || status;
    const phase = reviewAfterburnerPhaseLabel[rawPhase] || String(rawPhase).replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());
    return { value: phase, tone: 'run', status };
  }
  if (status === 'complete') {
    const summary = current.summary || {};
    const count = (value) => Number.isFinite(Number(value)) ? Number(value) : 0;
    const pass = count(summary.pass ?? summary.safe);
    const review = count(summary.review ?? summary.suspicious);
    const fail = count(summary.fail ?? summary.obviousFailures);
    const verdict = String(summary.finalVerdict || current.finalVerdict || (fail ? 'fail' : review ? 'review' : 'pass')).toLowerCase();
    return { value: `${pass} pass · ${review} review · ${fail} fail`, tone: verdict === 'fail' ? 'fail' : verdict === 'review' ? 'cond' : 'pass', status };
  }
  const reason = current.reason || current.error || current.eoa?.reason || current.eoaResult?.reason;
  if (reason) return { value: String(reason), tone: null, status };
  return { value: reviewAfterburnerPhaseLabel[current.phase] || reviewAfterburnerPhaseLabel[status] || status, tone: null, status };
}

Object.assign(window, { parseQaSummary, reviewAfterburnerCard, reviewAfterburnerPhaseLabel, BIcon, BI, CmBox, rwDiff, rwIsolatedPreview, useBuildBlocks, BeFrame, useBeChase, WsRenderSlot });
